import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";


import ScrollToTop from "../../../components/scroll-to-top";

export default function Privacy(){
    return(
        <>
        <Navbar navClass="defaultscroll is-sticky"/>
        <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="text-3xl leading-normal font-semibold">Privacy Policy</h3>
                </div>
            </div>
            
            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="/">Sportyfi</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="">Policies</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold text-orange-500" aria-current="page">Privacy Policy</li>
                </ul>
            </div>
        </section>

         <section className="py-10 px-6 max-w-4xl mx-auto  shadow text-gray-800 leading-relaxed">
     
      <p className="mb-6">
        At <strong>sportyfi</strong> (<a
          href="https://www.sportyfi.in/"
          className="text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.sportyfi.in/
        </a>), we are committed to protecting your privacy and ensuring your
        personal information is handled in a safe and responsible manner. This
        Privacy Policy outlines how we collect, use, and safeguard your
        information when you shop with us online.
      </p>

      {/* 1. Information We Collect */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        1. Information We Collect
      </h2>
      <p className="mb-3">We collect the following types of information when you interact with our website:</p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          <strong>Personal Information:</strong> Name, email address, phone
          number, shipping & billing address.
        </li>
        <li>
          <strong>Payment Information:</strong> Payments are processed securely
          via third-party gateways (e.g., Razorpay, PayU, Stripe). We do not
          store your card or payment details on our servers.
        </li>
        <li>
          <strong>Account Information:</strong> If you create an account, we
          store your login credentials (encrypted) and order history.
        </li>
        <li>
          <strong>Device & Usage Data:</strong> IP address, browser type, access
          times, referring websites, and pages viewed.
        </li>
        <li>
          <strong>Cookies & Tracking Technologies:</strong> Used to enhance user
          experience, enable cart functionality, and provide product suggestions.
        </li>
      </ul>

      {/* 2. How We Use Your Information */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Processing orders and managing your account.</li>
        <li>Delivering products to your address.</li>
        <li>Sending order confirmations and updates.</li>
        <li>Providing customer support.</li>
        <li>Improving our website and services.</li>
        <li>Sending promotional offers (only if you opt in).</li>
      </ul>

      {/* 3. Sharing Your Information */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        3. Sharing Your Information
      </h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          Trusted third-party services (e.g., payment gateways, shipping
          providers) for order fulfillment.
        </li>
        <li>
          Marketing platforms (e.g., Meta, Google) for targeted promotions, only
          with your consent.
        </li>
        <li>
          Legal authorities, when required by law or to protect our rights and
          property.
        </li>
      </ul>

      {/* 4. Data Security */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        4. Data Security
      </h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>SSL encryption for all transactions.</li>
        <li>Regular security audits.</li>
        <li>Secure servers and password encryption.</li>
      </ul>

      {/* 5. Your Rights */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">5. Your Rights</h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Access and update your personal information.</li>
        <li>Request deletion of your data.</li>
        <li>Opt out of marketing emails at any time.</li>
        <li>Request data portability or correction.</li>
      </ul>
      <p className="mb-6">
        To exercise these rights, contact us at{" "}
        <strong>sportyfi@gmail.com</strong>.
      </p>

      {/* 6. Cookies */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">6. Cookies</h2>
      <p className="mb-3">We use cookies to:</p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Remember your preferences.</li>
        <li>Enable cart and checkout functionality.</li>
        <li>
          Track performance and user behavior (e.g., via Meta Pixel and Google
          Analytics).
        </li>
      </ul>
      <p className="mb-6">
        You can manage or disable cookies anytime in your browser settings.
      </p>

      {/* 7. Third-Party Links */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        7. Third-Party Links
      </h2>
      <p className="mb-6">
        Our website may contain links to third-party websites. We are not
        responsible for the privacy practices or content of these external
        sites.
      </p>

      {/* 8. Children’s Privacy */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        8. Children’s Privacy
      </h2>
      <p className="mb-6">
        We do not knowingly collect data from children under the age of 13. If
        you believe your child has provided personal information, please contact
        us immediately.
      </p>

      {/* 9. Changes to This Policy */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        9. Changes to This Policy
      </h2>
      <p className="mb-6">
        We may update this Privacy Policy periodically. Any changes will be
        reflected on this page with an updated effective date.
      </p>

      {/* 10. Contact Us */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">10. Contact Us</h2>
      <p className="mb-2">For questions or concerns about your data, please contact:</p>
      <ul className="list-none pl-0 space-y-1">
        <li>
          <strong>sportyfi</strong> – Modest Fashion Redefined
        </li>
        <li>
          <strong>Email:</strong> sportyfi@gmail.com
        </li>
        <li>
          <strong>Location:</strong> Sambit Villa, Ghatikia, Bhubaneswar, India
        </li>
      </ul>
    </section>
        <Footer/>
        <Switcher/>
        <ScrollToTop/>
        </>
    )
}